const MY_SELF_RELATIONSHIP_ID = 1
const INHERITANCE_OCCURS_EVENT_MASTER_KEYS = ['event_myself_7', 'event_parent_4', 'event_parent_5', 'event_wife_6']
const BACKWARD_DAY = '04-02'
const NOTE_TYPE = {
  DISPUTE_ANS: 'DISPUTE_ANS',
  TAX_CALCULATION: 'TAX_CALCULATION',
  MEMBER_NOTE: 'MEMBER_NOTE',
  LIFE_EVENT: 'LIFE_EVENT'
}

const BACKWARD_DAY_EVENT_NAME = ['小学校入学', '中学校入学', '高校入学', '大学入学', '成人', '就職']

const MAP_COLOR_ANKEN = new Map([
    ['商品区分', ''],
    ['不クリ', ''],
    ['ＲＣ', ''],
    ['スポット消費税還付', ''],
    ['スポットその他', ''],
    ['スポット確定申告', ''],
    ['遺クリＰ３', 'bg1'],
    ['遺クリＰ２', 'bg1'],
    ['遺クリＰ１', 'bg1'],
    ['遺クリＰ０', 'bg1'],
    ['遺クリＢ', 'bg1'],
    ['遺クリＡＡ', 'bg1'],
    ['遺クリＡＳ', 'bg1'],
    ['遺クリZ', 'bg1'],
    ['相続税還付', 'bg2'],
    ['法人疎開資産税', 'bg3'],
    ['信託', 'bg3'],
    ['事業承継・Ｍ＆Ａ', 'bg3'],
    ['財産対策', 'bg3'],
    ['資産税リアル', 'bg4'],
    ['リアル仲介', 'bg4'],
    ['リアル建築', 'bg4'],
    ['リアルトラブル', 'bg4'],
    ['広大地リアル', 'bg4'],
    ['法人疎開リアル', 'bg4'],
    ['遺クリＡＡＣ', 'bg5'],
    ['ＦＰ顧問', ''],
    ['遺クリＰ２Ｎ', 'bg1'],
    ['遺クリＰ１Ｎ', 'bg1'],
    ['遺クリＰ０Ｎ', 'bg1'],
    ['遺クリＢＮ', 'bg1'],
    ['遺クリＡＡＮ', 'bg5'],
    ['遺クリＡ', 'bg1'],
    ['財産対策Ｎ', 'bg3'],
    ['α　相続', 'bg1'],
    ['β', ''],
    ['β１', ''],
    ['γ', ''],
    ['δ', ''],
    ['相続　FC', ''],
    ['α　会計', ''],
    ['遺クリＡＡＳＣ', 'bg5'],
    ['安心プラン', 'bg3'],
    ['税金診断', 'bg3'],
    ['遺言', 'bg3'],
    ['登記', ''],
    ['受取手数料', ''],
    ['遺クリＡＡＳＮ', 'bg5'],
    ['安心プランＮ', 'bg3'],
    ['税金診断Ｎ', 'bg3'],
    ['遺言Ｎ', 'bg3'],
    ['資産税リアルＮ', 'bg4'],
    ['遺クリＡＡＧ', 'bg5'],
    ['遺クリＡＡＣＧ', 'bg5'],
    ['遺クリＡＡＮＧ', 'bg5'],
    ['事業承継・Ｍ＆ＡＮ', 'bg3'],
    ['Ｇｒ税理士業務管理手数料', ''],
    ['Ｇｒ行政書士業務管理手数料', ''],
    ['法人疎開資産税Ｎ', 'bg3'],
    ['法人疎開リアルＮ', 'bg4'],
    ['リアル売仲介', 'bg4'],
    ['リアル買仲介', 'bg4'],
    ['リアル売仲介Ｎ', 'bg4'],
    ['リアル買仲介Ｎ', 'bg4'],
    ['リアル建築Ｎ', 'bg4'],
    ['リアルトラブルＮ', 'bg4'],
    ['広大地リアルＮ', 'bg4'],
    ['遺クリＰ３Ｎ', 'bg1'],
    ['信託Ｎ', 'bg3'],
    ['オフィス入館用', '']
])

const HEADER_X_IS_MAINTENANCE = 'x-ismaintenance'
const HTTP_STATUS_MAINTENANCE = 499 // ELBのヘルスチェックをすり抜けるため4xx台とする

export {
  MY_SELF_RELATIONSHIP_ID,
  INHERITANCE_OCCURS_EVENT_MASTER_KEYS,
  NOTE_TYPE,
  BACKWARD_DAY,
  BACKWARD_DAY_EVENT_NAME,
  MAP_COLOR_ANKEN,
  HEADER_X_IS_MAINTENANCE,
  HTTP_STATUS_MAINTENANCE
}
